export function gtagEvent(
  action: string,
  data?:
    | {
        category?: string | null | undefined;
        label?: string | null | undefined;
        value: number | null | undefined;
      }
    | null
    | undefined
) {
  window.gtag("event", action, {
    event_category: data?.category ?? "engagement",
    event_label: data?.label ?? "",
    value: data?.value ?? 1,
  });
}
